/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Mitra_ExtraInputs */

const en_cp_p_mitra_extra = /** @type {(inputs: Cp_P_Mitra_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ program fee IDR 2.5M/semester`)
};

const id_cp_p_mitra_extra = /** @type {(inputs: Cp_P_Mitra_ExtraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ biaya program Rp 2,5 jt/semester`)
};

/**
* | output |
* | --- |
* | "+ program fee IDR 2.5M/semester" |
*
* @param {Cp_P_Mitra_ExtraInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_mitra_extra = /** @type {((inputs?: Cp_P_Mitra_ExtraInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Mitra_ExtraInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_mitra_extra(inputs)
	return en_cp_p_mitra_extra(inputs)
});